import { ofType } from 'redux-observable';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import JobProApi from '../../dependencies/JobProApi';
import config from 'config.json';
import { fetchAvailableEmployees } from '../searchEmployees'

const JOB_FIELDS = 'id,address(city,line1,line2,state,zip),capacities(laborAmount),contacts(isPrimaryContact,name,firstName,lastName,cellPhone,workPhone,email),customer(id,name),items(item(itemType(id,name)),proposedQuantity),jobNumber,jobTotal,jobType,location,office(id,name),name,profit(actualProfit,proposedProfit),salesperson(calendarColor,firstName,lastName),status,priorityNotes';

// Action types
const FETCH_AVAILABLE_JOBS = 'FETCH_AVAILABLE_JOBS';
const FETCH_AVAILABLE_JOBS_COMPLETE = 'FETCH_AVAILABLE_JOBS_COMPLETE';
const SEARCH_CUSTOMERS = 'FETCH_CUSTOMERS';
const SEARCH_CUSTOMERS_COMPLETE = 'FETCH_CUSTOMERS_COMPLETE';
const UPDATE_SEARCH_CRITERIA = 'UPDATE_SEARCH_CRITERIA';
const SET_JOB_TOGGLE = 'SET_JOB_TOGGLE';

const DEFAULT_STATE = {
  form: {
    bidTypes: [],
    jobStatuses: [],
    jobTypes: [],
    offices: [],
    salespeople: []
  },
  customers: {
    customers: [],
    loading: false
  },
  jobs: [],
  loading: false,
  jobToggle:{
    togleState: false,
    toggleClass:'fa fa-chevron-left'
   },
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_AVAILABLE_JOBS:
      return {
        ...state,
        jobs: [],
        loading: true
      };
    case FETCH_AVAILABLE_JOBS_COMPLETE:
      return {
        ...state,
        ...payload,
        loading: false
      };
    case SEARCH_CUSTOMERS:
      return {
        ...state,
        customers: {
          customers: [],
          loading: true
        }
      };
    case SEARCH_CUSTOMERS_COMPLETE:
      return {
        ...state,
        customers: {
          customers: payload.customers,
          loading: false
        }
      };
    case UPDATE_SEARCH_CRITERIA:
      return {
        ...state,
        form: {
          ...state.form,
          ...payload
        },
        loading: true
      };
      case SET_JOB_TOGGLE:
        return {
          ...state,
          jobToggle:payload          
        };
    default:
      return state;
  }
}

// Action creators
export const fetchAvailableJobs = () => ({
  type: FETCH_AVAILABLE_JOBS
});

const fetchAvailableJobsComplete = (jobs) => ({
  type: FETCH_AVAILABLE_JOBS_COMPLETE,
  payload: { jobs }
});

export const searchCustomers = (query) => ({
  type: SEARCH_CUSTOMERS,
  payload: { query }
});

const searchCustomersComplete = (customers) => ({
  type: SEARCH_CUSTOMERS_COMPLETE,
  payload: { customers }
});

export const openJob = (jobId) => {
  window.open(`${config.versaItRoot}display.asp?key=6081&fo=basic%20display&rm=page&xID=${jobId}`);
};

export const updateSearchCriteria = (criteria) => {
  return (dispatch) => {
    dispatch({type: UPDATE_SEARCH_CRITERIA, payload: criteria})
    dispatch(fetchAvailableEmployees());
  }
};

/*export const updateSearchCriteria = (criteria) => ({
  type: UPDATE_SEARCH_CRITERIA,
  payload: criteria
});*/

export const setJobToggle = (toggle) => ({
  type: SET_JOB_TOGGLE,
  payload:  toggle 
});
// Epics
export const fetchAvailableJobsEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_AVAILABLE_JOBS, UPDATE_SEARCH_CRITERIA),
  debounceTime(300),
  switchMap(() => {
    const { bidTypes, customerId, jobStatuses, jobTypes, offices, query, salespeople } = state$.value.searchJobs.form;

    // Build API filter criteria
    const criteria = {
      processComplete: false
    };
    if (query) {
      criteria.query = query;
    }
    if (bidTypes.length) {
      criteria['bid.category'] = bidTypes.map((t) => t.value);
    }
    if (customerId) {
      criteria['customer.id'] = customerId;
    }
    if (jobStatuses.length) {
      criteria.status = jobStatuses.map((s) => s.value);
    }
    if (jobTypes.length) {
      criteria.type = jobTypes.map((t) => t.name);
    }
    if (offices.length) {
      criteria.office = offices.map((o) => o.name);
    }
    if (salespeople.length) {
      criteria['salesperson.id'] = salespeople.map(s => s.id);
    }

    return JobProApi.jobs.search(criteria, {
      fields: JOB_FIELDS,
      limit: 50
    });
  }),
  map(fetchAvailableJobsComplete),
);

export const searchCustomersEpic = (action$) => action$.pipe(
  ofType(SEARCH_CUSTOMERS),
  debounceTime(300),
  switchMap(({ payload }) => {
    const { query } = payload;
    return JobProApi.customers.search({
      query
    }, {
        fields: 'id,name'
      });
  }),
  map(searchCustomersComplete),
);
